import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../config';
import Navbar from '../components/landing/Navbar';
import HeroSection from '../components/landing/HeroSection';
import SocialProof from '../components/landing/SocialProof';
import QuoteSection from '../components/landing/QuoteSection';
import WhyChooseUs from '../components/landing/WhyChooseUs';
import Process from '../components/landing/Process';
import Comparison from '../components/landing/Comparison';
import FAQ from '../components/landing/FAQ';
import FinalCTA from '../components/landing/FinalCTA';
import Footer from '../components/landing/Footer';
import NewsletterSection from '../components/landing/NewsletterSection';
import SocialMediaButtons from '../components/SocialMediaButtons';
import Testimonials from '../components/Testimonials';
import FAQSection from '../components/FAQSection';
import StatsCounter from '../components/StatsCounter';

const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const response = await axios.get(`${API}/landing-config/public`);
      setConfig(response.data);
    } catch (error) {
      console.log('Error loading config, using defaults');
      setConfig({});
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1d1e20] flex items-center justify-center">
        <div className="text-white text-xl">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#1d1e20]">
      <Navbar config={config} />
      <HeroSection config={config} />
      
      {/* Stats Counter with animations - Replaces SocialProof */}
      <StatsCounter type="model" />
      
      <QuoteSection config={config} />
      <WhyChooseUs config={config} />
      <Process config={config} />
      
      {/* Testimonials from Real Models */}
      <Testimonials type="model" />
      
      <Comparison config={config} />
      
      {/* Enhanced FAQ Section */}
      <FAQSection type="model" />
      
      <FinalCTA config={config} />
      <NewsletterSection />
      <Footer config={config} />
      
      {/* Floating Social Media Buttons */}
      <SocialMediaButtons variant="floating" brandColors={true} />
    </div>
  );
};

export default HomePage;